import { fetchApiVersion } from "~/utils/fetchApiVersion";

/**
 * API version loaded once on full page load / hard refresh.
 * useState + module cache keep SPA navigations from re-fetching.
 */
export function useApiVersion() {
  const apiVersion = useState<string | null>("apiVersion", () => null);
  const hasRequested = useState<boolean>("apiVersionRequested", () => false);

  onMounted(() => {
    if (hasRequested.value) {
      return;
    }
    hasRequested.value = true;

    const config = useRuntimeConfig();
    void fetchApiVersion(String(config.public.apiBase ?? "")).then((version) => {
      apiVersion.value = version;
    });
  });

  return { apiVersion };
}
